import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.091 4.642a.68.68 0 0 0-.947.114c-.231.29-.178.71.115.938l16.65 12.914a.68.68 0 0 0 .947-.114.664.664 0 0 0-.115-.938l-2.959-2.293c1.114-1.13 1.868-2.397 2.247-3.296a.88.88 0 0 0 0-.684c-.419-.994-1.299-2.441-2.615-3.649C16.092 6.415 14.272 5.391 12 5.391c-1.918 0-3.516.732-4.761 1.692zm5.184 4.019A4.05 4.05 0 0 1 12 7.617c2.236 0 4.05 1.795 4.05 4.008 0 .693-.177 1.344-.49 1.912l-1.085-.84c.146-.329.225-.69.225-1.072 0-1.475-1.21-2.672-2.7-2.672q-.119 0-.236.011a1.76 1.76 0 0 1 .05 1.667zm6.274 8.294-2.058-1.603c-.462.18-.965.28-1.491.28-2.236 0-4.05-1.794-4.05-4.007q0-.288.04-.562L5.336 8.995c-.64.827-1.1 1.65-1.367 2.288a.88.88 0 0 0 0 .684c.42.994 1.3 2.441 2.616 3.649 1.322 1.219 3.142 2.243 5.414 2.243a7.45 7.45 0 0 0 3.55-.904"
    }, null, -1)
  ]))]))
}
export default { render: render }